module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-purchase/boxoffice-purchase.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-purchase/boxoffice-purchase.component.scss
// module chunks = 9